// SEO Crawlability Enhancement Script
// This script improves search engine crawling and indexing

document.addEventListener('DOMContentLoaded', function() {
  // Enhance HTML semantics for better crawlability
  function enhanceHTMLSemantics() {
    // Add semantic article tags to blog posts
    if (document.querySelector('.article')) {
      const articleContent = document.querySelector('.article__content');
      if (articleContent && articleContent.tagName !== 'ARTICLE') {
        const article = document.createElement('article');
        article.innerHTML = articleContent.innerHTML;
        articleContent.innerHTML = '';
        articleContent.appendChild(article);
      }
    }
    
    // Add semantic section tags to collections
    const collectionGrid = document.querySelector('.collection__products');
    if (collectionGrid && collectionGrid.tagName !== 'SECTION') {
      const section = document.createElement('section');
      section.setAttribute('aria-label', 'Product collection');
      section.innerHTML = collectionGrid.innerHTML;
      collectionGrid.innerHTML = '';
      collectionGrid.appendChild(section);
    }
    
    // Add proper heading hierarchy
    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
    const headingLevels = {};
    
    headings.forEach(heading => {
      const level = parseInt(heading.tagName.substring(1));
      headingLevels[level] = (headingLevels[level] || 0) + 1;
    });
    
    // Check if there's only one H1
    if (headingLevels[1] > 1) {
      // Find all H1s except the first one
      const h1s = document.querySelectorAll('h1');
      for (let i = 1; i < h1s.length; i++) {
        // Replace with H2
        const h2 = document.createElement('h2');
        h2.innerHTML = h1s[i].innerHTML;
        h2.className = h1s[i].className;
        h1s[i].parentNode.replaceChild(h2, h1s[i]);
      }
    }
  }
  
  // Fix broken links and redirects
  function fixBrokenLinks() {
    const links = document.querySelectorAll('a[href]');
    
    links.forEach(link => {
      const href = link.getAttribute('href');
      
      // Fix common issues
      if (href === '#' || href === 'javascript:void(0)') {
        // Replace empty links with more semantic alternatives
        if (link.getAttribute('onclick')) {
          // Keep onclick functionality but make it more accessible
          link.setAttribute('role', 'button');
          link.setAttribute('tabindex', '0');
        } else {
          // If it's just a placeholder, make it a span
          const span = document.createElement('span');
          span.innerHTML = link.innerHTML;
          span.className = link.className;
          link.parentNode.replaceChild(span, link);
        }
      }
      
      // Fix relative links
      if (href && href.startsWith('/') && !href.startsWith('//')) {
        // Ensure canonical domain
        const canonicalDomain = 'https://lybstore.com';
        link.setAttribute('href', `${canonicalDomain}${href}`);
      }
    });
  }
  
  // Add structured data for FAQ sections
  function addFAQStructuredData() {
    const faqSections = document.querySelectorAll('.faq, .accordion, [class*="faq"], [class*="accordion"]');
    
    if (faqSections.length === 0) return;
    
    const faqItems = [];
    
    faqSections.forEach(section => {
      // Look for question-answer pairs
      const questions = section.querySelectorAll('.faq__question, .accordion__title, [class*="question"], [class*="title"]');
      const answers = section.querySelectorAll('.faq__answer, .accordion__content, [class*="answer"], [class*="content"]');
      
      if (questions.length === answers.length) {
        for (let i = 0; i < questions.length; i++) {
          faqItems.push({
            '@type': 'Question',
            'name': questions[i].textContent.trim(),
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': answers[i].textContent.trim()
            }
          });
        }
      }
    });
    
    if (faqItems.length > 0) {
      // Create FAQ structured data
      const faqSchema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': faqItems
      };
      
      // Add to page
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(faqSchema);
      document.head.appendChild(script);
    }
  }
  
  // Optimize pagination for SEO
  function optimizePagination() {
    const pagination = document.querySelector('.pagination');
    
    if (!pagination) return;
    
    // Get current URL and page number
    const url = new URL(window.location.href);
    const currentPage = parseInt(url.searchParams.get('page') || '1');
    
    // Find next/prev links
    const nextLink = pagination.querySelector('.pagination__next');
    const prevLink = pagination.querySelector('.pagination__prev');
    
    // Add rel attributes for proper crawling
    if (nextLink) {
      nextLink.setAttribute('rel', 'next');
    }
    
    if (prevLink) {
      prevLink.setAttribute('rel', 'prev');
    }
    
    // Add pagination meta tags
    if (nextLink) {
      const nextURL = nextLink.getAttribute('href');
      const nextMeta = document.createElement('link');
      nextMeta.rel = 'next';
      nextMeta.href = nextURL.startsWith('http') ? nextURL : `${window.location.origin}${nextURL}`;
      document.head.appendChild(nextMeta);
    }
    
    if (prevLink) {
      const prevURL = prevLink.getAttribute('href');
      const prevMeta = document.createElement('link');
      prevMeta.rel = 'prev';
      prevMeta.href = prevURL.startsWith('http') ? prevURL : `${window.location.origin}${prevURL}`;
      document.head.appendChild(prevMeta);
    }
  }
  
  // Execute enhancements
  enhanceHTMLSemantics();
  fixBrokenLinks();
  addFAQStructuredData();
  optimizePagination();
});
